import React, { useEffect, useState } from "react";
import { testimonials } from "../../v3/data";

const initials = (name) =>
  name
    .split(" ")
    .map((w) => w[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

const featured = testimonials.filter((t) => t.tag);

const Spotlight = () => {
  const [i, setI] = useState(0);
  const f = featured[i];

  useEffect(() => {
    const t = setTimeout(() => setI((n) => (n + 1) % featured.length), 8000);
    return () => clearTimeout(t);
  }, [i]);

  const arrowStyle = { width: 42, height: 42, borderRadius: "50%", fontSize: 15, cursor: "pointer" };

  return (
    <div className="card tc" style={{ maxWidth: 900, margin: "0 auto 30px", padding: "52px 40px 34px" }}>
      <div key={i} className="fadeup">
        <div className="mono fw6" style={{ fontSize: 12, letterSpacing: ".14em", color: "var(--accent)", marginBottom: 24 }}>
          {f.tag}
        </div>
        <blockquote
          className="disp"
          style={{
            fontSize: f.quote.length > 240 ? "clamp(16px, 1.8vw, 21px)" : "clamp(19px, 2.3vw, 26px)",
            fontWeight: 700,
            lineHeight: 1.4,
            letterSpacing: "-.015em",
            margin: "0 auto 30px",
            maxWidth: 740,
          }}
        >
          “{f.quote}”
        </blockquote>
        <div className="fx ac gap12" style={{ justifyContent: "center" }}>
          <span className="tm-avatar" style={{ background: "var(--accent)", color: "#fff", border: "none", width: 46, height: 46 }}>
            {initials(f.name)}
          </span>
          <span className="col tc" style={{ gap: 1, alignItems: "flex-start" }}>
            <span className="fw6" style={{ fontSize: 15 }}>{f.name}</span>
            <span className="fs13" style={{ color: "var(--muted)" }}>{f.role}</span>
          </span>
        </div>
        <div className="mono" style={{ fontSize: 11, color: "#059669", marginTop: 16, letterSpacing: ".1em" }}>
          [✓] VERIFIED CLIENT · 5.0 <span style={{ color: "#F59E0B", fontSize: 14 }}>★★★★★</span>
        </div>
      </div>
      <div className="fx ac gap16" style={{ justifyContent: "center", marginTop: 28 }}>
        <button
          type="button"
          className="socbtn"
          style={arrowStyle}
          aria-label="Previous testimonial"
          onClick={() => setI((i - 1 + featured.length) % featured.length)}
        >
          ←
        </button>
        <span className="mono" style={{ fontSize: 12.5, color: "var(--muted)", letterSpacing: ".1em" }}>
          {String(i + 1).padStart(2, "0")} / {String(featured.length).padStart(2, "0")}
        </span>
        <button
          type="button"
          className="socbtn"
          style={arrowStyle}
          aria-label="Next testimonial"
          onClick={() => setI((i + 1) % featured.length)}
        >
          →
        </button>
      </div>
    </div>
  );
};

const TmCard = ({ tm }) => (
  <div className="card tm-card">
    <div className="disp" style={{ fontSize: 32, lineHeight: 0.6, color: "var(--accent-line)", marginBottom: 10 }}>
      “
    </div>
    <p className="f1 tm-quote" style={{ fontSize: 14, lineHeight: 1.6, margin: "0 0 16px" }}>
      {tm.quote}
    </p>
    <div className="fx ac gap12" style={{ borderTop: "1px solid var(--line)", paddingTop: 14 }}>
      <span className="tm-avatar">{initials(tm.name)}</span>
      <span className="col f1" style={{ gap: 1, minWidth: 0 }}>
        <span className="fw6 fs14">{tm.name}</span>
        <span className="fs13" style={{ color: "var(--muted)" }}>
          {tm.role}
        </span>
      </span>
      <span className="mono" style={{ fontSize: 15, color: "#F59E0B", letterSpacing: 2, flexShrink: 0 }}>
        ★★★★★
      </span>
    </div>
  </div>
);

const Row = ({ items, reverse }) => (
  <div className={`marq tm-marq${reverse ? " rev" : ""}`}>
    <div className="marq-inner">
      {[...items, ...items].map((tm, i) => (
        <TmCard tm={tm} key={i} />
      ))}
    </div>
  </div>
);

const Testimonials = () => {
  return (
    <section id="testimonials" className="section soft rv" style={{ overflow: "hidden" }}>
      <div className="pagewrap">
        <div className="shead">
          <div>
            <div className="snum">[ 06 / TESTIMONIALS ]</div>
            <h2 className="h2">
              Trusted by the
              <br />
              people I build for.
            </h2>
          </div>
          <span className="mono hide-mobile" style={{ fontSize: 12, color: "var(--muted)" }}>
            HOVER TO PAUSE · {String(testimonials.length).padStart(2, "0")} REVIEWS
          </span>
        </div>
        <Spotlight />
        <div
          className="fx jb wrap gap12 mono"
          style={{ fontSize: 11.5, color: "var(--muted)", letterSpacing: ".08em", padding: "0 0 34px" }}
        >
          <span>RATED 5.0 / 5.0</span>
          <span className="hide-mobile">·</span>
          <span>TOP RATED PLUS · UPWORK</span>
          <span className="hide-mobile">·</span>
          <span>100% JOB SUCCESS</span>
          <span className="hide-mobile">·</span>
          <span>100+ PROJECTS DELIVERED</span>
        </div>
      </div>
      <Row items={testimonials} />
    </section>
  );
};

export default Testimonials;
